export default "__VITE_ASSET__c1aa4c83__"